import React from 'react';

import cx from 'classnames';
import { Trans } from 'react-i18next';

import { noop } from 'helpers';
import { useTheme } from 'hooks';
import { CrossIcon } from 'styles/assets/icons';
import optionComobosSlides from 'styles/assets/images/options_combos_slides/optionCombos';
import { Box } from 'UIKit';
import IconButton from 'UIKit/IconButton';
import DeltaButton from 'UIKit/DeltaButton/DeltaButton';

import OptionsCombosDesktopSlideAdditionalElement from '../OptionsCombosDesktopSlideAdditionalElement';
import styles from './style.module.scss';

interface ActiveSlideType {
  id: number;
  title: string;
  file_name: string;
  sub_text: string;
  identifier: string;
}

interface OptionsCombosDesktopSlideType {
  activeSlide: ActiveSlideType;
  handleModalClose: React.MouseEventHandler<HTMLButtonElement>;
  handleNextClick: (
    event: React.MouseEvent<HTMLButtonElement>,
    data: { id: number }
  ) => void;
  totalCount: number;
  buttonText: string;
}

const OptionsCombosDesktopSlide = ({
  activeSlide,
  handleModalClose,
  handleNextClick,
  totalCount,
  buttonText,
}: OptionsCombosDesktopSlideType) => {
  const { id, title, file_name: fileName, identifier } = activeSlide;
  const { activeTheme } = useTheme();

  const slideImgPath = !fileName ? '' : optionComobosSlides[fileName];

  const rowOneTwoWrapperClassNames = cx(styles.rowOneTwoWrapper, {
    [styles.rowOneTwoWrapperDarkBg]: activeTheme === 'dark',
  });

  return (
    <Box className={styles.container}>
      <Box className={rowOneTwoWrapperClassNames}>
        <Box className={styles.rowOne}>
          <Box className={styles.currentSlideCountContainer}>
            <span className={`${styles.text} ${styles.currentText}`}>{id}</span>
            <span className={styles.seperator}>/</span>
            <span className={`${styles.text} ${styles.totalText}`}>{totalCount}</span>
          </Box>
          <Box className={styles.title}>{title}</Box>
          <IconButton
            onClick={handleModalClose}
            data-testid="close-button-options-combos-slide"
            className={styles.crossIcon}
            icon={<CrossIcon />}
            onKeyDown={noop}
          />
        </Box>
        <Box className={styles.rowTwo}>
          <img src={slideImgPath} alt={title} className={styles.image} />
        </Box>
      </Box>
      <Box className={styles.rowThree}>
        <span>
          <Trans
            i18nKey={
              `trading:options_combos_slides.slide_data.${identifier}.sub_text` as any
            }
            components={[<OptionsCombosDesktopSlideAdditionalElement />]}
          />
        </span>
      </Box>
      <Box className={styles.rowFour}>
        <DeltaButton
          onClick={e => handleNextClick(e, { id })}
          minWidth={140}
          data-testid="next-button-options-combos-slide"
          testId="next-button-options-combos-slide"
        >
          {buttonText}
        </DeltaButton>
      </Box>
    </Box>
  );
};

export default OptionsCombosDesktopSlide;
